<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12">
      <h1>Настройки</h1>
    </v-col>
    <v-col cols="12" sm="12">
      <v-text-field   label="Минимальная версия iOS приложения"
                      outlined
                      v-model="minIOSVersion.value"
                      @blur="updateMinIOSVersion()"/>
      <v-text-field   label="Минимальная версия Android приложения"
                      outlined
                      v-model="minAndroidVersion.value"
                      @blur="updateAndroidVersion()"/>
      <v-btn :loading="loadingGlovoMenu" @click="exportGlovoMenu">Выгрузить в Глово меню</v-btn>
      <v-btn :loading="loadingEshoGlovoMenu" @click="exportEshoGlovoMenu">Выгрузить в Глово меню ЕШО</v-btn>
    </v-col>
    <v-col cols="12">
      <h2 class="mb-4">Интро видео</h2>
      <video v-if="introVideo.value" :src="introVideo.value" controls width="100%" class="mb-4" style="max-width: 500px; display: block"></video>
      <v-file-input
          label="Загрузить новое интро видео"
          accept="video/*"
          outlined
          @change="uploadVideo"
          :loading="loadingVideo"
      ></v-file-input>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src

import SettingService from './../../api/SettingService'

export default {
  name: 'SettingIndex',
  components: {},
  data: () => ({
    minIOSVersion: {},
    minAndroidVersion: {},
    introVideo: {},
    loadingGlovoMenu: false,
    loadingEshoGlovoMenu: false,
    loadingVideo: false,
  }),
  mounted() {
    SettingService.get('min_ios_version').then(response => {
      this.minIOSVersion = response.data
    });

    SettingService.get('min_android_version').then(response => {
      this.minAndroidVersion = response.data
    });

    SettingService.get('intro_video').then(response => {
      this.introVideo = response.data
    });

  },
  watch: {},
  methods: {

    async exportGlovoMenu(){
      this.loadingGlovoMenu = true
      await SettingService.exportGlovoMenu()
      this.loadingGlovoMenu = false
    },
    async exportEshoGlovoMenu(){
      this.loadingEshoGlovoMenu = true
      await SettingService.exportEshoGlovoMenu()
      this.loadingEshoGlovoMenu = false
    },
    updateMinIOSVersion() {
      SettingService.update(this.minIOSVersion.id, {value: this.minIOSVersion.value})
    },
    updateAndroidVersion() {
      SettingService.update(this.minAndroidVersion.id, {value: this.minAndroidVersion.value})
    },
    async uploadVideo(file) {
      if (!file) return;
      this.loadingVideo = true
      try {
        const response = await SettingService.uploadVideo(file)
        const videoUrl = response.data.video
        await SettingService.update(this.introVideo.id, {value: videoUrl})
        this.introVideo.value = videoUrl
      } catch (e) {
        console.error(e)
      } finally {
        this.loadingVideo = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
